import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "word",
  "use": "word-usage",
  "viewBox": "0 0 83.3 102.9",
  "content": "<symbol viewBox=\"0 0 83.3 102.9\" id=\"word\"><path fill=\"#285497\" d=\"M53.2 27.7V11.3H14.4v75.1h52V27.7z\" /><path fill=\"#3388ad\" d=\"M66.4 27.7L53.2 11.3v16.4z\" /><path fill=\"none\" d=\"M18.2 44.7h47.3v16.2H18.2z\" /><text transform=\"translate(18.208 55.985)\" font-size=\"15\" font-family=\"Roboto\" fill=\"#fff\">WORD</text></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/word.svg
// module id = wyj0
// module chunks = 1